import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID,
};

const app = initializeApp(firebaseConfig);

export const auth = getAuth(app);
// Initialize Firestore, optionally targeting a non-default database instance
const dbName = import.meta.env.VITE_FIREBASE_DATABASE_ID;
let db;
if (dbName) {
  // If the env var is already a full resource path, use it directly
  if (dbName.startsWith("projects/")) {
    db = getFirestore(app, dbName);
  } else {
    // Build the Firestore resource string for this database ID
    const projectId = firebaseConfig.projectId;
    db = getFirestore(app, `${dbName}`);
  }
} else {
  // Default database
  db = getFirestore(app);
}

// Initialize Firebase Functions
export const functions = getFunctions(app);

// Connect to emulators in development mode
if (import.meta.env.DEV && false) {
  connectFunctionsEmulator(getFunctions(app), "http://localhost:5003");
  //  connectAuthEmulator(auth, "http://localhost:9099");
  connectFirestoreEmulator(db, "localhost", 8080);
}

export { db };
